import * as z from "zod";
import { requiredString } from "components/form/utils";

export const questionSchema = z.object({
  question: requiredString(),
  status: z.string().optional(),
  category: requiredString(),
});
